import { __assign } from "tslib";
import React, { useRef } from 'react';
import { cn } from '@bem-react/classname';
import { useButton } from '@use-platform/react/semantic/button';
import './CloseButton.css';
var cnCloseButton = cn('UserID', 'CloseButton');
export var CloseButton = function (props) {
    var onClick = props.onClick, colorScheme = props.colorScheme;
    var buttonRef = useRef(null);
    var buttonProps = useButton({ onPress: onClick, 'aria-label': 'Закрыть', tabIndex: 1 }, buttonRef).buttonProps;
    return (React.createElement("button", __assign({ className: cnCloseButton({ colorScheme: colorScheme }) }, buttonProps),
        React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", focusable: "false", "aria-hidden": "true" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z", fill: "currentColor" }))));
};
